<template>
  <a-spin :spinning="loading">
    <a-alert banner :show-icon="false" :message="getInsuranceMessage"/>
    <a-table
      :columns="columns"
      :data-source="insuranceData.players"
      :rowKey="getRowKey"
      style="background: #fafafa;"
      :bordered="false"
      size="small"
      :row-selection="{
        onChange: onChange,
        getCheckboxProps: record => ({props: {disabled: record.status === 1 || insuranceData.insuranceStatus === 2, name: record.carId }}),
        selectedRowKeys: selectedRowKeys
      }"
      :pagination="false">
      <div class="player" slot="name" slot-scope="text, record">
        <img :src="record.head || defaultHead"/>
        <span>{{ record.name }}</span>
      </div>
      <a-tag slot="status" :color="text === 0 ? '#f50' : '#87d068'" slot-scope="text">{{ insuranceData.insuranceStatus === 2 ? '无需缴纳保险' : (text === 0 ? '未缴费' : '已缴费') }}</a-tag>
      <div class="footer" slot="footer">
        <div class="btn">
<!--          <div v-if="selectedRows.length > 0">{{ getAmount() }}</div>-->
          <BuyInsuranceBtn
            :btnDisabled="selectedRows.length === 0"
            ref="buyInsuranceBtn"
            :agencyId="agencyId"
            :needPhonePlayers="needPhonePlayers"
            :name="buyInsuranceBtnName"
            @buyInsurance="buyInsurance">
          </BuyInsuranceBtn>
        </div>
        <div v-if="selectedRows.length > 0">
          <a-checkbox v-model="bxChecked" >我已查看并同意
            <!-- <a href="http://mechanism.daoba.com/word/tiaokuan.doc">“保险条款”</a> -->
            <a href="https://static.daoba.com//791546521809.docx">“客户告知书”</a>
          </a-checkbox>
        </div>
      </div>
    </a-table>
    <InsuranceType ref="insuranceType" @insuranceTypeOk="insuranceTypeOk"></InsuranceType>
    <PayQrCode ref="payQrCode" @paySuccess="paySuccess"/>
  </a-spin>
</template>
<script>
import store from '@/store'
import InsuranceType from '@comm/components/join/pay/InsuranceType'
import BuyInsuranceBtn from '@comm/components/join/pay/BuyInsuranceBtn'
import PayQrCode from '@comm/components/join/pay/PayQrCode'
const columns = [
  { title: '队员', dataIndex: 'name', scopedSlots: { customRender: 'name' } },
  { title: '缴费状态', dataIndex: 'status', scopedSlots: { customRender: 'status' } }
]
export default {
  components: {
    BuyInsuranceBtn,
    InsuranceType,
    PayQrCode
  },
  data () {
    return {
      loading: false,
      defaultHead: require('@comm/assets/join/photo.png'),
      matchInfo: store.getters['match/matchInfo'],
      buyInsuranceBtnName: '购买已选队员保险',
      agencyId: Number(this.$route.query.agencyId),
      insuranceData: {
        insuranceStatus: 0, // 保险费缴费类型 0,不强制，1必须缴纳，2不缴纳
        insuranceMoney: 20, // 保险费价格
        players: []
      },
      columns: columns,
      rowSelection: [],
      bxChecked: false,
      selectedRows: [],
      needPhonePlayers: [],
      selectedRowKeys: []
    }
  },
  mounted () {
    this.queryInsuranceData()
  },
  methods: {
    getRowKey (record) {
      return record.cardId
    },
    onChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    // 查询保险费购买信息
    queryInsuranceData (toNext) {
      this.loading = true
      let matchId = this.$route.query.matchId
      let agencyId = this.$route.query.agencyId
      this.$api.join.queryInsuranceData(matchId, agencyId).then(res => {
        if (res.status === 0) {
          this.insuranceData = res.data
          if (toNext) {
            let toNextPage = true
            for (let i = 0; i < this.insuranceData.players.length; i++) {
              if (this.insuranceData.players[i].status === 0) {
                toNextPage = false
                break
              }
            }
            if (toNextPage) {
              this.$emit('paySuccess')
            }
          }
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log('err', err)
        this.$message.error('保险信息获取失败')
      }).finally(_ => {
        this.loading = false
      })
    },
    getInsuranceMessage () {
      let insuranceStatus = this.insuranceData.insuranceStatus
      let msg = '保险缴费类型：'
      switch (insuranceStatus) {
      case 0:
        msg += '不强制'
        break
      case 1:
        msg += '必须缴纳'
        break
      case 2:
        msg += '免保险费'
        break
      }
      // let insuranceMoney = this.insuranceData.insuranceMoney
      // msg += '  保险金额：￥' + insuranceMoney + '元/人'
      return msg
    },
    getAmount () {
      if (this.selectedRows.length === 0) {
        return '￥0.0'
      } else {
        let amount = 0
        this.selectedRows.forEach(() => {
          amount += 20
        })
        return '￥' + amount
      }
    },
    buyInsurance (insuranceType) {
      if (!this.bxChecked) {
        this.$message.error('请先阅读并同意《客户告知书》')
        return
      }
      this.$refs.insuranceType.show()
    },
    createPostParams (insuranceType) {
      let choiceIds = []
      this.selectedRows.forEach(item => {
        if (item.status === 0) {
          choiceIds.push(item.cardId)
        }
      })
      if (choiceIds.length === 0) {
        this.$message.error('选择队员都已经购买过保险')
        return false
      }
      let params = {
        agencyId: this.$route.query.agencyId,
        cardIds: choiceIds,
        matchId: this.$route.query.matchId,
        payType: 'PC',
        insuranceTypeId: insuranceType.insuranceTypeId
      }
      return params
    },
    paySuccess () {
      this.selectedRows = []
      this.selectedRowKeys = []
      // 如果所有人的保险费都已经购买，则跳转到下一步
      this.queryInsuranceData(true)
    },
    // 保险费是否支付完成，如果保险费的支付为强制购买，则必须所有队员都购买了保险才算支付完成
    payOver () {
      if (this.insuranceData.insuranceStatus === 1) {
        let hasNoPayPlayer = this.insuranceData.players.some(player => player.status === 0)
        return !hasNoPayPlayer
      }
      return true
    },
    insuranceTypeOk (insuranceType) {
      // this.$emit('buyInsurance', insuranceType)

      let params = this.createPostParams(insuranceType)
      if (params === false) {
        return
      }
      this.loading = true
      this.$api.join.createInsuranceOrderByType(params).then(res => {
        if (res.status === 0) {
          // 判断是否有需要输入监护人电话的人
          let needPhonePlayers = res.data.needPhonePlayers
          if (needPhonePlayers != null && needPhonePlayers.length > 0) {
            this.needPhonePlayers = []
            needPhonePlayers.forEach(npp => {
              this.needPhonePlayers.push({cardId: npp.cardId, name: npp.name, image: npp.image, phone: undefined})
            })
            this.$refs.buyInsuranceBtn.show()
          } else {
            this.$refs.payQrCode.show(res.data)
          }
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('保险订单创建失败')
      }).finally(_ => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .description {
    text-align: center;
    padding: 10px;
    span {
      color: #989898;font-size: 18px;
    }
  }
  .player {
    img {
      height: 50px;
      width: 40px;
    }
    span {
      margin-left: 10px;
      font-size: 16px;
    }
  }
  .footer {
    text-align: right;
    .btn {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      div {
        color: #e6990c;
        font-size: 30px;
        margin-bottom: 0px;
        margin-right: 30px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/comm/components/join/pay/InsuranceAmount.vue